import {Injectable} from '@angular/core';
import * as glob from '../global';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ShareService {
    public permission: string = '';

    constructor(private _httpClient: HttpClient) {
    }

    refreshToken(): any {
        this._httpClient.post<any>(glob.BASE_URL + 'intelisys/refresh-token', {}, {observe: 'response'})
            .pipe(map(res => {
                console.log(res);
            }));
    }

}
